var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "imageCropping" },
    [
      _c(
        "el-upload",
        {
          staticClass: "avatar-uploader upload",
          attrs: {
            action: _vm.avatarUploadUrl,
            "show-file-list": false,
            "before-upload": _vm.beforeAvatarUpload,
          },
        },
        [
          _vm.avatar
            ? _c("img", { staticClass: "avatar", attrs: { src: _vm.avatar } })
            : _c("i", { staticClass: "el-icon-plus avatar-uploader-icon" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "avatarDialog",
          attrs: {
            title: "截取图片",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "append-to-body": "",
            width: "35%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("vueCropper", {
            ref: "cropper",
            attrs: {
              img: _vm.imgData,
              info: _vm.option.info,
              size: _vm.option.size,
              full: _vm.option.full,
              fixed: _vm.option.fixed,
              fixedNumber: _vm.option.fixedNumber,
              outputSize: _vm.option.size,
              outputType: _vm.option.outputType,
              autoCrop: _vm.option.autoCrop,
              fixedBox: _vm.option.fixedBox,
              centerBox: _vm.option.centerBox,
              original: _vm.option.original,
              canMoveBox: _vm.option.canMoveBox,
              canScale: _vm.option.canScale,
              autoCropWidth: _vm.option.autoCropWidth,
              autoCropHeight: _vm.option.autoCropHeight,
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$refs.cropper.rotateLeft()
                    },
                  },
                },
                [_vm._v("左转90度")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$refs.cropper.rotateRight()
                    },
                  },
                },
                [_vm._v("右转90度")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.submitIMGData } }, [
                _vm._v("确 定"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/imageCropping.vue?vue&type=template&id=441197c6&
// module id = null
// module chunks = 